export type RemovePayloadCart = {
    type: "cart" | "group" | "product" | "item";
    id: string | number;
};

export const buildQuoteRemoveUrl = (
    payload: RemovePayloadCart,
    quoteId: string | number,
): string => {
    const { type, id } = payload;
    let url = `quotes/remove/items`;

    switch (type) {
        case "cart":
            url += `?quoteId=${id}`;
            break;
        case "group":
            url += `?quoteId=${quoteId}&groupId=${id}`;
            break;
        case "product":
            url += `?quoteId=${quoteId}&productId=${id}`;
            break;
        case "item":
            url += `?quoteId=${quoteId}&quoteItemId=${id}`;
            break;
        default:
            throw new Error(`Invalid delete type: ${type}`);
    }

    return url;
};

export const buildCartRemoveUrl = (payload: RemovePayloadCart, sessionId?: string): string => {
    const { type, id } = payload;
    const url = `cart/remove/items`;
    const params = new URLSearchParams();

    switch (type) {
        case "cart":
            if (sessionId) {
                params.set("sessionId", sessionId);
            } else {
                params.set("isCart", "1");
            }
            break;
        case "group":
            params.set("groupId", id.toString());
            if (sessionId) params.set("sessionId", sessionId);
            break;
        case "product":
            params.set("productId", id.toString());
            if (sessionId) params.set("sessionId", sessionId);
            break;
        case "item":
            params.set("cartItemId", id.toString());
            if (sessionId) params.set("sessionId", sessionId);
            break;
        default:
            throw new Error(`Invalid delete type: ${type}`);
    }

    return `${url}?${params.toString()}`;
};
